import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WorksApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS, {
			entity: 'works',
		})
	}
}
